/**
 * This file contains the Vuex Actions (https://vuex.vuejs.org/guide/actions.html) intended to be accessible for unauthorized users
 * @Author Andrew Gunter
 */

import axios from 'axios'
import Api from '@/store/api'
import jwt_decode from "jwt-decode";
import VueRouter from 'vue-router';
import routes from '@/routes/auth-routes'
import ociUtils from '@/common/resources/ociUtils.js'
import {ERROR} from "./mutation-types";

export default {
  addPerson({commit},person){
    Api
      .post('person',person)
      .then(r => r.data)
      .then(newPerson => {
        commit('ADD_PERSON', newPerson)
        commit('LOAD_APPLICANT_BY_PROFILE_ID', newPerson)
        ociUtils.global.showSwal({type: "success", title: "Saved", text: "", timer: 5000});
      }).catch((error) =>{
      let ociAppError = error.response.data;
      ociAppError.title = "Error Saving Profile";
      commit("ERROR",error.response.data)
    })
  },
  uploadProfilePic({commit}, file) {
    Api.post('uploadFile', file)
      .then(function () {
      })
      .catch((error) => {
        console.log(error);
        let ociAppError = "Invalid picture format";
        commit("ERROR", ociAppError)
      });
  },
  previewProfilePic({commit}, filename) {
    function Uint8ToString(u8a) {
      let CHUNK_SZ = 0x8000;
      let c = [];
      for (let i = 0; i < u8a.length; i += CHUNK_SZ) {
        c.push(String.fromCharCode.apply(null, u8a.subarray(i, i + CHUNK_SZ)));
      }
      return c.join("");
    }
    Api
      .get("downloadFile?key=" + filename.get('file'),
        {
          responseType: 'arraybuffer',
        })
      .then((response) => {
        let contentTypeObj = JSON.stringify(response.headers);
        let contents = contentTypeObj.split('"content-type":"', 2)[1];//retrieving content-type from headers (stringify-ing/parsing didn't work)
        let format = contents.split('"', 2)[0];//retrieving content-type from headers (stringify-ing/parsing didn't work)
        if (format === "image/png") {
          let b64encoded = btoa(Uint8ToString(new Uint8Array(response.data)));
          let image = "data:image/png;base64, " + b64encoded;
          commit('LOAD_PROFILE_PICTURE', image);
        }
      })
      .catch((error) => console.log(error))
      .catch(function () {
      });
  }, //Unauthorized
  purchaserWizardDataByToken({commit},token){
    commit('UPDATE_ALL_APPLICATION_APPLICANT_LOADING',true) //used to alert components that data is being loaded for this state object, triggers loader on some pages
    Api
      .get('appApplicant/wizard/appApplicantToken?client='+token.token)
      .then(r => r.data)
      .then(appApplicants => {
        //for now just extract the only application applicant and put into allApplicationApplicants
        commit('ALL_APPLICATION_APPLICANTS',appApplicants )
        // this.dispatch("getAppApplicantHistoryPurchaserByAppApplicantId",{token:token.token,appApplicantId:appApplicants[0].applicationApplicantId});
        commit('UPDATE_ALL_APPLICATION_APPLICANT_LOADING',false)
      }).catch((error) => {
      commit('UPDATE_ALL_APPLICATION_APPLICANT_LOADING',false)
      commit("UPDATE_PURCHASER_CONSENT",true)
      let ociAppMessage = {
        title: "Invalid Client Link",
        message: "",
        displayType:"error",
        name: "tokenErrorMessage",
        httpCode:error.response.status
      }
      switch (error.response.status) {
        case 404:
          ociAppMessage.message="Please, ensure you have used the correct  link provided to you or contact One Close Support Staff if error continues!";
          break;
        default :
          ociAppMessage.message= "Server Error, Contact One Close Tech Support Staff!";
          break;
      }
      commit("UPDATE_OCI_APP_MESSAGE",ociAppMessage)
    })
  }, //Unauthorized
  /*
    Auth and Session Management
 */
  sessionInfoCheck({commit}){
    Api
      .get('/auth/sic')
      .then(r=> r.data)
      .then(sic => {
        commit('UPDATE_SESSION_INFO',sic);
      });
  }, //unauthorized
  sendLoginCredentials({commit},authRequest){
    Api
      .post('/auth/login',authRequest)
      .then(r=> r.data)
      .then(authResponse => {
        commit('UPDATE_AUTH_RESPONSE',authResponse)
        if(authResponse.res===1){
          sessionStorage.setItem('ocu',authResponse.token);
          let decoded = jwt_decode(authResponse.token);
          commit('AUTH_SUCCESS',authResponse.token);
          this.dispatch('LOAD_APP_USER',decoded);
          ociUtils.appState.clearDeprecatedData()
          this.dispatch("sessionInfoCheck");
        }
        else {
          sessionStorage.removeItem('ocu') // if the request fails, remove any possible user token if possible;
        }
      }).catch(function(error){
      sessionStorage.removeItem('ocu') // if the request fails, remove any possible user token if possible;
    })
  },//unauthorized
  refreshToken({commit}){
    Api
      .get('/auth/extend')
      .then(r=> r.data)
      .then(authResponse => {
        commit('UPDATE_AUTH_RESPONSE',authResponse)
        sessionStorage.setItem('ocu',authResponse.token);
        let decoded = jwt_decode(authResponse.token);
        commit('AUTH_SUCCESS',authResponse.token);
        this.dispatch('LOAD_APP_USER',decoded);
        ociUtils.appState.clearDeprecatedData()
        this.dispatch("sessionInfoCheck");
      }).catch(function(error){
      commit("ERROR",error.response.data);
    });
  }, //unauthorized
  /* Used if redirection flow to different app after login
processToken({commit},token){
  Api
    .post('/auth/validate',token)
    .then(r=> r.data)
    .then(authResponse => {
      commit('UPDATE_AUTH_RESPONSE',{res:1,token:token})
      sessionStorage.setItem('ocu',token);
      let decoded = jwt_decode(token);
      commit('AUTH_SUCCESS',token);
      this.dispatch('LOAD_APP_USER',decoded);
      ociUtils.appState.clearDeprecatedData()
    });
},
*/
  cancelResetPassword({commit},authRequest){
    Api
      .post('/auth/reset/cancel',authRequest)
      .then(r=> r.data)
      .then(authResponse => {
        commit('UPDATE_AUTH_RESPONSE',authResponse)
      });
  } ,//unauthorized
  resetPassword({commit},authRequest){
    Api
      .post('/auth/reset',authRequest)
      .then(r=> r.data)
      .then(authResponse => {
        commit('UPDATE_AUTH_RESPONSE',authResponse)
      });
  }, //unauthorized
  forgotPassword({commit},authRequest){
    Api
      .post('/auth/forgot',authRequest)
      .then(r=> r.data)
      .then(authResponse => {
        commit('UPDATE_AUTH_RESPONSE',authResponse)
      });
  }, //unauthorized
  //unauthorized
  getUserClaims({commit},encodedToken){
    Api
      .post('auth/issue', {bearer:encodedToken}).then(
      response=>{
        sessionStorage.setItem('ocu',response.data.bearer);
        let decoded = jwt_decode(response.data.bearer);
        commit('AUTH_SUCCESS',response.data.bearer);
        this.dispatch('LOAD_APP_USER',decoded);
        ociUtils.appState.clearDeprecatedData();
      }
    ).catch(function(error){
      console.log(error);
      sessionStorage.removeItem('ocu') // if the request fails, remove any possible user token if possible
    })
  }, //unauthorized
  revokeToken({commit}){
    Api
      .post('auth/revoke').then(
      response=>{
        commit('AUTH_LOGOUT')
        commit('LOAD_APP_USER',{ //reset appUser to avoid console error logs for perimeters
          firstName:'',
          lastName:'',
          userId: 0,
          roles: [],
          profileId: 0,
          exp:0,
          iat:0,
          firmProfileId:'',
          firmName:0,
          firmDomain:'',
          firmRepId:0,
        })
      }
    ).catch(function(error){
      console.log(error);
      commit('AUTH_LOGOUT')
    })
  }, //unauthorized
  registerUser({commit},registrationDetails){
    Api
      .post('auth/register/confirmed',registrationDetails)
      .then(r => r.data)
      .then(user => {
        commit("UPDATE_OCI_APP_MESSAGE",
          {
            title:"Registration Successful",
            message:"You have registered successfully!",
            name:"registrationMessage",
            displayType:"info",
            httpCode:201
          }
        )
      }).catch((error) =>{
      console.error(error.response)
      let ociAppMessage = {
        title: "Registration Error",
        message: "",
        displayType:"error",
        name: "registrationMessage",
        httpCode:error.response.status
      }
      switch (error.response.status) {
        case 409:
          ociAppMessage.message="We already have a registered account on file for you!";
          break;
        default :
          ociAppMessage.message= "Contact One Close Tech Support Staff!";
          break;
      }
      commit("UPDATE_OCI_APP_MESSAGE",ociAppMessage)
    })
  }, //unauthorized
  forcePassword({commit},authRequest){
    Api
      .post('/auth/force',authRequest)
      .then(r=> r.data)
      .then(authResponse => {
        commit('UPDATE_AUTH_RESPONSE',authResponse)
      });
  }, //unauthorized
  resetForcedPassword({commit},request){
    Api
      .post('/auth/reset/enable',request)
      .then(r=> r.data)
      .then(authResponse => {
        commit('UPDATE_AUTH_RESPONSE',authResponse)
      });
  }, //unauthorized

  /*Start of actions that should be refactored into mutations*/
  LOAD_APP_USER({commit},decodedToken){
    commit('LOAD_APP_USER',decodedToken);
    commit('SET_USER_ROLES');
  },
  AUTH_LOGOUT: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit('AUTH_LOGOUT')
      resolve()
    })
  },
  increment({commit}) {
    commit('increment')
  },
  changeCount({commit},count) {
    commit('changeCount',count)
  },
  setEnrollmentPhase ({commit},phase){
    commit('SET_ENROLLMENT_PHASE',phase)
  },
  addRecentNotification({commit},notification){
    commit('ADD_RECENT_NOTIFICATION', notification)
  },
  setNotificationHistoryDisplay({commit},notification){
    commit('SET_NOTIFICATION_HISTORY_DISPLAY', notification)
  },
  updateBrokerChatPageOpen({commit},value){
    commit('UPDATE_BROKER_CHAT_PAGE_OPEN', value)
  },
  updateBrokerMiniChatOpen({commit},value){
    commit('UPDATE_BROKER_MINI_CHAT_OPEN', value)
  },
  updateMonthlyRent({commit},value){
    commit('UPDATE_MONTHLY_RENT', value)
  },
  updateOccupancyType({commit},value){
    commit('UPDATE_OCCUPANCY_TYPE', value)
  },
  /*End of actions that should be refactored into mutations*/
}
